import { render, staticRenderFns } from "./MessageCreate.vue?vue&type=template&id=0ee76a87&scoped=true&"
import script from "./MessageCreate.vue?vue&type=script&lang=js&"
export * from "./MessageCreate.vue?vue&type=script&lang=js&"
import style0 from "./MessageCreate.vue?vue&type=style&index=0&id=0ee76a87&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ee76a87",
  null
  
)

export default component.exports